export default "__VITE_ASSET__DM_B33LN__"